// extracted by mini-css-extract-plugin
module.exports = {"header":"AuditTrailModal_header__3CwmZ","status":"AuditTrailModal_status__31x55","empty_handler":"AuditTrailModal_empty_handler__NHLBT"};